"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameConnectedStrategy = exports.DefaultConnectedStrategy = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
class ConnectedCreator {
}
/**
 * DefaultConnectedStrategy determines if the track is in a connected state
 * by examning if a given video track is defined or not
 */
class DefaultConnectedStrategy extends ConnectedCreator {
    constructor(track) {
        super();
        this.track = track;
    }
    createConnected() {
        return this.track.pipe((0, operators_1.map)(track => !!track));
    }
}
exports.DefaultConnectedStrategy = DefaultConnectedStrategy;
/**
 * NameConnectedStrategy determines if the track is in a connected state
 * by examining if a VideoTrack WallItem and a VideoTrack have the same name
 */
class NameConnectedStrategy extends ConnectedCreator {
    constructor(wallItem, track) {
        super();
        this.wallItem = wallItem;
        this.track = track;
    }
    createConnected() {
        return (0, rxjs_1.combineLatest)([this.wallItem, this.track]).pipe((0, operators_1.switchMap)(([item, track]) => {
            if (!item || !track) {
                return (0, rxjs_1.of)(false);
            }
            if (!item.name || !track.name) {
                return (0, rxjs_1.of)(false);
            }
            return (0, rxjs_1.of)(track.name === item.name);
        }));
    }
}
exports.NameConnectedStrategy = NameConnectedStrategy;
//# sourceMappingURL=connected_strategy.js.map